import { render, staticRenderFns } from "./link-pagination.vue?vue&type=template&id=d4e6fcc0&"
import script from "./link-pagination.vue?vue&type=script&lang=js&"
export * from "./link-pagination.vue?vue&type=script&lang=js&"
import style0 from "./link-pagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports